<template>
    <div class="v-main__wrap-bg">
        <v-container style="height: 100%" background-color="grey" >
            <v-row justify="center" align="center" >
                <v-col class="py-5">
                    <v-img
                        src="../../public/e-swarlogo@2x.png"
                        width="110"
                        style="margin: auto"
                    ></v-img>
                </v-col>
            </v-row>

            <v-row justify="center" align="center" dense>
                <v-card outlined width="370" tile>
                    <v-card-title class="justify-center">
                        <h2 class="login-box-msg">Login</h2>
                    </v-card-title>
                    <v-row no-gutters>
                        <v-card-text 
                            class="text-center my-20 mx-7" 
                            justify="center" 
                            align="center"
                        >Enter your login details to access your account</v-card-text>
                    </v-row>
            
                    <v-form v-model="valid" class="px-5" @submit.prevent="Login" dense>
                        <v-text-field
                            v-model="email"
                            type="email"
                            label="Email"
                            outlined
                            class="b-tile"
                            clearable
                            append-icon="mdi-email"
                            :rules="emailRules"
                            :success="emailSuccess"
                        ></v-text-field>

                        <v-text-field
                            v-model="password"
                            ref="password"
                            :type="showPassword ? 'text' : 'password'"
                            class="mt-1 b-tile"
                            label="Password"
                            outlined
                            clearable
                            append-icon="mdi-eye"
                            :rules="passwordRules"
                            :success="passwordSuccess"
                            @click:append="showPassword = !showPassword"
                        >
                        </v-text-field>

                            <v-alert v-if="serverError" type="error">
                                {{serverError}}
                            </v-alert>
                    
                            <v-row class="right">
                                <v-spacer></v-spacer>
                                    <router-link to="/forgotpassword" class="forget-pass mr-4" 
                                        >Forgot Password?
                                    </router-link>
                            </v-row>
                            <v-card-actions class="px-0">
                                <v-row class="justify-center" dark>
                                    <v-btn 
                                        class="btn-login my-5"
                                        type="submit"
                                        :disabled="disabled"
                                        @click="logIn"
                                        >LOGIN
                                    </v-btn>
                                </v-row>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-row>
            </v-container>
            <div class="strip-outer">
                <div class="strip-bottom"></div>
            </div>
        </div>
</template>

<script>
import { mapMutations } from "vuex";
import url1 from '../../config.js';
export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (vm.$store.state.auth.adminUser._id)
                    vm.$router.push("/admin/dashboard");
            }, 0);
        });
    },

    data() {
        return {
            url:`${url1.url}`,
            serverError: "",
            valid: false,
            disabled: true,
            showPassword: false,
            email: "",
            emailSuccess: false,
            password: "",
            passwordSuccess: false,
            emailRules: [
                v => {
                    if (v) {
                        this.emailSuccess = true;
                        return true;
                    } else {
                        return "E-mail is required";
                    }
                },
                v => /.+@.+\..+/.test(v) || "Please enter valid email address"
            ],
            passwordRules: [
                v => {
                    if (v) {
                        this.passwordSuccess = true;
                        return true;
                    } else {
                        return "Password is required";
                    }
                },
                v =>
                    (v || "").length >= 8 ||
                    "Password must be at least 8 characters long"
            ] 
        };
    },

    methods: {
       ...mapMutations(["setToken", "setUser"]),

        logIn()
        {
            this.disabled = true;
            this.$axios.post(this.url+"/api/auth", {
                adminUserEmail: this.email,
                adminUserPassword: this.password
            })
            .then((res)=>{
                localStorage.setItem("token", res.headers["x-auth-token"]);
                this.setToken(res.headers["x-auth-token"]);
                this.setUser(res.data);
                this.$router.replace("/admin/dashboard");
            })
            .catch(err => {
                //console.log(err);
                this.serverError = err.response.data;
                setTimeout(() => (this.serverError = ""), 5000);
                this.disabled = false;
            });
        }
    },

    watch: {
        valid(val) {
            if (val) {
                this.disabled = false;
            } else {
                this.disabled = true;
            }
        }
    }
};
</script>
<style scoped>
.b-tile >>> .v-input__slot {
    min-height: 40px;
    background: #e8f0fe;
}
.b-tile >>> .v-label {
    top: 10px;
    font-weight: 500;
    font-size: 14px;
}
.b-tile >>> .v-input__append-inner {
    margin-top: 8px;
}
.b-tile >>> .v-icon.v-icon {
    color: #1b73ba61;
}
.btn-login {
    border-radius: 0;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    border-width: 1px;
    width: 50%;
    font-weight: normal;
    display: block;
    margin: auto;
    background: #3c8dbc !important;
    border-color: #367fa900;
    border: 1px solid transparent;
    color: #fff;
}
</style>